<div class="cashback-popup" *ngIf="!_as.isOnMobilePlatform">
    <p-dialog header="Header" [(visible)]="_cashback.displayCashbackDialog" [style]="{width: '600px'}" [draggable]="false" [modal]="true" [closeOnEscape]="false"
    [transitionOptions]="'350ms cubic-bezier(0, 0, 0.2, 1)'">
        <ng-template pTemplate="header">Apply Cashback</ng-template>
        <ng-template pTemplate="content">
            <div class="dc-row">
                
            <div class="dc-dealer" *ngIf="_cashback.dealer">
                <label for="integer" class="font-bold block"> Seller </label>
                <div class="d-flex align-items-center">
                    <div class="dc-1">
                        <img [src]="_cashback.dealer?.showroom_image_list[0]?.showroom_image_url"
                            *ngIf="_cashback.dealer?.showroom_image_list[0]?.showroom_image_url"
                            [alt]="_cashback.dealer?.showroom_name">
                    </div>
                    <div class="dc-2">
                        <h4>{{_cashback.dealer?.showroom_name}}</h4>
                        <p><span>{{_cashback.dealer?.address2}},</span> {{_cashback.dealer?.city}}</p>
                    </div>
                </div>
            </div>
            </div>
            <div class="dc-row">
            <div class="dc-pro">
                <label for="integer" class="font-bold block mb-2"> Professional </label>
                <span class="p-float-label" style="    margin-top: 16px;">
                    <!-- <input pInputText id="professionl_phone" pKeyFilter="int" (keyup)="mobileExist($event)" [(ngModel)]="_cs.professionl_phone" /> -->
                    <input maxlength="10" id="professionl_mobile"  class="form-control rsp-input w-100 text-left" type="tel" size="30"
                        [(ngModel)]="_cashback.professionl_phone" numbersOnly pInputText autocomplete="none|false|no"
                        (keydown.space)="$event.preventDefault();" required (keyup)="mobileExist($event,'pros')">
                        <label for="professionl_mobile">Mobile</label>
                    <div class="icon-don" *ngIf="isMobileExited">
                        <i class="pi pi-check-circle"></i>
                    </div>
                </span>
                <div class="found-customer" *ngIf="ref_by_name"> <span>Professional name: </span>{{ref_by_name}}</div>
                <div class="warrning-message" *ngIf="!isMobileExited && isCheckedProNumber"> <strong>Note:</strong> No Professional is available from the entered mobile number</div>
                <span class="p-float-error" *ngIf="_cashback.is_submit && !_cashback.professionl_phone">Plaese enter professional mobile required</span>
            </div>
            <div class="dc-pro" *ngIf=" (!isMobileExited && isCheckedProNumber) || (_cashback.is_submit && _cashback.pro_name_required)">
                <span class="p-float-label mt-2" *ngIf="!isMobileExited && isCheckedProNumber">
                    <input class="form-control rsp-input w-100 text-left" type="text" size="30"
                        [(ngModel)]="_cashback.professionl_name" pInputText autocomplete="none|false|no" required>
                    <label for="professionl_name">Professional name</label>
                </span>
                <span class="p-float-error" *ngIf="_cashback.is_submit && _cashback.pro_name_required">Plaese enter professional name required</span>
                <p class="without-pro" *ngIf="_cashback.is_submit && _cashback.pro_name_required">If you can not professional Plaese <a
                        (click)="_cashback.submitWithoutProd()">click here to skip</a> </p>
            </div>
            <p-overlayPanel #termRef>
                <ng-template pTemplate="content">
                    <div class="terms-card">
                        <h6>Terms and conditions</h6>
                        <ul class="terms-ul">
                            <li>Contrary to popular belief, Lorem Ipsum is not simply random text. </li>
                            <li>It has roots in a piece of classical Latin literature</li>
                            <li>The standard chunk of Lorem Ipsum used since the 1500s</li>
                        </ul>
                    </div>

                </ng-template>
            </p-overlayPanel>
            <span *ngIf="!isMobileExited && isCheckedProNumber" class="p-float-note">Give professional name and get
                a
                referral amount <a (click)="termRef.toggle($event)">terms and conditions applied</a></span>
            </div>
            <div class="dc-row">
                <div class="dc-invoice" *ngIf="_cashback.invoice">
                    <div class="dc-1" *ngIf="_cashback.file_type!=='pdf'">
                        <img [src]="_cashback.invoice_url" [alt]="this._cashback.invoice?.name" *ngIf="_cashback.invoice_url" />
                    </div>
                    <div class="dc-1" *ngIf="_cashback.file_type==='pdf'">
                        <img src="https://res.cloudinary.com/afterbricks/image/upload/v1657624347/pdf_sldrmf.png"
                            alt="pdf">
                    </div>
                    <div class="dc-2">
                        <span>{{this._cashback.invoice?.name}}</span>
                    </div>
                </div>
                <div class="dc-invoice" *ngIf="!_cashback.invoice">
                    <div class="upload-file" [ngClass]="{'invoice-shake':_cashback.is_invoice_receipt_not_upload}">
                        <label for="f2" class="font-bold block mb-2" *ngIf="!_cashback.file ">
                            <span>Upload Invoice</span>
                            <i class="fa-solid fa-receipt"></i>
    
                        </label>
                        <input type="file" accept="image/png, image/jpeg, image/jpg, application/pdf" id="f2"
                            (change)="_cashback.uploadInvoice($event)" />
                    </div>
    
                </div>
            </div>
            <div class="term-and-condition">
                <span>I confirm that I have accepted and agreed to all the <a>terms and conditions</a> .</span>
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <div class="d-flex align-items-center justify-content-end">
               <button class="cancel-btn" (click)="_cashback.closeCashback()">Cancel</button>
                <button class="dc-fbtn" (click)="_cashback.onSubmit()">Submit</button>
            </div>
            
        </ng-template>
    </p-dialog>
</div>
<div class="cashback-popup" *ngIf="_as.isOnMobilePlatform">
    <p-sidebar header="Header" [(visible)]="_cashback.displayCashbackDialog" [showCloseIcon]="false" [style]="{width: '100%'}" position="bottom" [draggable]="false" [modal]="true" [closeOnEscape]="false"
    [transitionOptions]="'350ms cubic-bezier(0, 0, 0.2, 1)'">
        <ng-template pTemplate="header">Apply Cashback</ng-template>
        <ng-template pTemplate="content">
            <div class="dc-row">
                
            <div class="dc-dealer" *ngIf="_cashback.dealer">
                <label for="integer" class="font-bold block"> Seller </label>
                <div class="d-flex align-items-center">
                    <div class="dc-1">
                        <img [src]="_cashback.dealer?.showroom_image_list[0]?.showroom_image_url"
                            *ngIf="_cashback.dealer?.showroom_image_list[0]?.showroom_image_url"
                            [alt]="_cashback.dealer?.showroom_name">
                    </div>
                    <div class="dc-2">
                        <h4>{{_cashback.dealer?.showroom_name}}</h4>
                        <p><span>{{_cashback.dealer?.address2}},</span> {{_cashback.dealer?.city}}</p>
                    </div>
                </div>
            </div>
            </div>
            <div class="dc-row">
            <div class="dc-pro">
                <label for="integer" class="font-bold block mb-2"> Professional </label>
                <span class="p-float-label" style="    margin-top: 16px;">
                    <!-- <input pInputText id="professionl_phone" pKeyFilter="int" (keyup)="mobileExist($event)" [(ngModel)]="_cs.professionl_phone" /> -->
                    <input maxlength="10" id="professionl_mobile" class="form-control rsp-input w-100 text-left" type="tel" size="30"
                        [(ngModel)]="_cashback.professionl_phone" numbersOnly pInputText autocomplete="none|false|no"
                        (keydown.space)="$event.preventDefault();" required (keyup)="mobileExist($event,'pros')">
                        <label for="professionl_mobile">Mobile</label>
                    <div class="icon-don" *ngIf="isMobileExited">
                        <i class="pi pi-check-circle"></i>
                    </div>
                </span>
                <div class="found-customer" *ngIf="ref_by_name"> <span>Professional name: </span>{{ref_by_name}}</div>
                <div class="warrning-message" *ngIf="!isMobileExited && isCheckedProNumber"> <strong>Note:</strong> No Professional is available from the entered mobile number</div>
                <span class="p-float-error" *ngIf="_cashback.is_submit && !_cashback.professionl_phone">Plaese enter professional mobile required</span>
            </div>
            <div class="dc-pro" *ngIf=" (!isMobileExited && isCheckedProNumber) || (_cashback.is_submit && _cashback.pro_name_required)">
                <span class="p-float-label mt-2" *ngIf="!isMobileExited && isCheckedProNumber">
                    <input class="form-control rsp-input w-100 text-left" type="text" size="30"
                        [(ngModel)]="_cashback.professionl_name" pInputText autocomplete="none|false|no" required>
                    <label for="professionl_name">Professional name</label>
                </span>
                <span class="p-float-error" *ngIf="_cashback.is_submit && _cashback.pro_name_required">Plaese enter professional name required</span>
                <p class="without-pro" *ngIf="_cashback.is_submit && _cashback.pro_name_required">If you can not professional Plaese <a
                        (click)="_cashback.submitWithoutProd()">click here to skip</a> </p>
            </div>
            <p-overlayPanel #termRef>
                <ng-template pTemplate="content">
                    <div class="terms-card">
                        <h6>Terms and conditions</h6>
                        <ul class="terms-ul">
                            <li>Contrary to popular belief, Lorem Ipsum is not simply random text. </li>
                            <li>It has roots in a piece of classical Latin literature</li>
                            <li>The standard chunk of Lorem Ipsum used since the 1500s</li>
                        </ul>
                    </div>

                </ng-template>
            </p-overlayPanel>
            <span *ngIf="!isMobileExited && isCheckedProNumber" class="p-float-note">Give professional name and get
                a
                referral amount <a (click)="termRef.toggle($event)">terms and conditions applied</a></span>
            </div>
            <div class="dc-row">
                <div class="dc-invoice" *ngIf="_cashback.invoice">
                    <div class="dc-1" *ngIf="_cashback.file_type!=='pdf'">
                        <img [src]="_cashback.invoice_url" [alt]="this._cashback.invoice?.name" *ngIf="_cashback.invoice_url" />
                    </div>
                    <div class="dc-1" *ngIf="_cashback.file_type==='pdf'">
                        <img src="https://res.cloudinary.com/afterbricks/image/upload/v1657624347/pdf_sldrmf.png"
                            alt="pdf">
                    </div>
                    <div class="dc-2">
                        <span>{{this._cashback.invoice?.name}}</span>
                    </div>
                </div>
                <div class="dc-invoice" *ngIf="!_cashback.invoice">
                    <div class="upload-file" [ngClass]="{'invoice-shake':_cashback.is_invoice_receipt_not_upload}">
                        <label for="f2" class="font-bold block mb-2" *ngIf="!_cashback.file ">
                            <span>Upload Invoice</span>
                            <i class="fa-solid fa-receipt"></i>
    
                        </label>
                        <input type="file" accept="image/png, image/jpeg, image/jpg, application/pdf" id="f2"
                            (change)="_cashback.uploadInvoice($event)" />
                    </div>
    
                </div>
            </div>
            <div class="term-and-condition">
                <span>I confirm that I have accepted and agreed to all the <a>terms and conditions</a> .</span>
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
        
               <button class="cancel-btn" (click)="_cashback.closeCashback()">Cancel</button>
                <button class="dc-fbtn" (click)="_cashback.onSubmit()">Submit</button>
            
            
        </ng-template>
    </p-sidebar>
</div>
